<template>
  <span>{{ $date(startDate, format) }} - {{ $date(endDate, format) }}</span>
</template>

<script>
export default {
  props: {
    start: { type: [String, Date], required: true },
    end: [String, Date],
    period: Number,
    format: { type: String, default: 'short' },
  },
  computed: {
    startDate() {
      return typeof this.start === 'string' ? new Date(this.start) : this.start;
    },
    endDate() {
      if (this.period) {
        const endDate = new Date(this.startDate.toISOString());
        endDate.setMonth(endDate.getMonth() + this.period);
        return endDate;
      }

      return typeof this.end === 'string' ? new Date(this.end) : this.end;
    },
  },
};

</script>
